import { remove, getConfiguration, getAllByElementId } from '@/api/pieceJointes/index';
import { GetAllByModuleType } from '@/api/typePieceJointe/index';
import { insertPieceJointe, updatePieceJointe } from '@/services/piecesJointes/savePiecesJointes';
import genererGuid from '@/services/general/genererGuid';
import * as types from './attachments-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    configuration: null,
    elementId: null,
    module: '',
    piecesJointes: [],
    showAddModal: false,
    typesPiecesJointes: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.ADD_PIECE_JOINTE](state, files) {
    files.forEach((file) => {
      if (!file.id) {
        file.id = genererGuid();
      }
    });
    state.piecesJointes.push(...files);
  },
  [types.REMOVE_PIECE_JOINTE](state, id) {
    const index = state.piecesJointes.findIndex(piece => piece.id === id);
    if (index >= 0) {
      state.piecesJointes.splice(index, 1);
    }
  },
  [types.SET_CONFIGURATION](state, config) {
    state.configuration = config;
  },
  [types.SET_ELEMENT_ID](state, id) {
    state.elementId = id;
  },
  [types.SET_LISTE_PIECE_JOINTE](state, liste) {
    state.piecesJointes = liste;
  },
  [types.SET_LISTE_TYPE_PIECE_JOINTE](state, liste) {
    state.typesPiecesJointes = liste;
  },
  [types.SET_LOGO](state, logo) {
    const index = state.piecesJointes.findIndex(piece => piece.placeType === 'Logo');
    if (index >= 0) {
      state.piecesJointes.splice(index, 1);
    }
    if (logo) {
      state.piecesJointes.push(logo);
    }
  },
  [types.SET_MODULE](state, modul) {
    if (state.module !== modul) {
      state.typesPiecesJointes = [];
    }
    state.module = modul;
  },
  [types.SET_SHOW_ADD_MODAL](state, val) {
    state.showAddModal = val;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.RESET_PIECES_JOINTES](state) {
    state.piecesJointes = [];
  },
};

const actions = {
  async insert({ state }, id) {
    await insertPieceJointe(state.piecesJointes, id, state.module);
  },
  // eslint-disable-next-line
  async delete({ getters }, id) {
    await remove(id);
  },
  async loadAttachments({ commit, state }) {
    if (state.elementId) {
      const responsePieceJointes = await getAllByElementId(state.elementId);
      commit(types.SET_LISTE_PIECE_JOINTE, responsePieceJointes.data.result.items);
    }
  },
  async setContext({ commit, getters }, data) {
    commit(types.SET_MODULE, data.module);
    if (getters.typesPiecesJointes.length === 0) {
      const responseTypePieceJointe = await GetAllByModuleType(data.module);
      commit(types.SET_LISTE_TYPE_PIECE_JOINTE, responseTypePieceJointe.data.result.items);
    }
    if (!getters.configuration) {
      const responsePiecesJointeConfiguration = await getConfiguration();
      commit(types.SET_CONFIGURATION, responsePiecesJointeConfiguration.data.result);
    }

    commit(types.SET_LISTE_PIECE_JOINTE, []);
  },
  setElementId({ commit, dispatch }, data) {
    if (data.id) {
      commit(types.SET_ELEMENT_ID, data.id);
      dispatch('loadAttachments');
    }
  },
  showAddModal({ commit }) {
    commit(types.SET_SHOW_ADD_MODAL, true);
  },
  async update({ state }, id) {
    if (id) {
      await updatePieceJointe(state.piecesJointes, id, state.module);
    } else await updatePieceJointe(state.piecesJointes, state.elementId, state.module);
  },
  async updateLogo({ state }, data) {
    const logo = data.logoPj || state.piecesJointes.find(p => p.placeType === 'Logo');
    if (!data.id || !logo) return;
    await updatePieceJointe([logo], data.id, state.module);
  },
  resetPiecesJointes({ commit }) {
    commit(types.RESET_PIECES_JOINTES);
  },
};

const getters = {
  configuration: state => {
    return state.configuration;
  },
  logo: state => {
    return state.piecesJointes.find(p => p.placeType === 'Logo');
  },
  piecesJointes: state => {
    return state.piecesJointes.filter(p => p.placeType !== 'Logo');
  },
  showAddModal: state => {
    return state.showAddModal;
  },
  typesPiecesJointes: state => {
    return state.typesPiecesJointes;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
